import { transport } from 'config/transport';

export function callApiGetPaymentSummariesByMonth(yearMonth) {
    return transport.get(`/mamnon/thuhocsinh/monthlySummary`, { params: { yearMonth } });
}
